export default __webpack_public_path__ + "static/Portfolio-8d826f437a047f932eedcc742934a205.png";